"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesSettings = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const uuid_1 = require("uuid");
const immutable_1 = require("immutable");
const lodash_1 = require("lodash");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const TurnedInNotRounded_1 = __importDefault(require("@mui/icons-material/TurnedInNotRounded"));
const core_1 = require("companion-app-components/utils/core");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const QButton_1 = __importDefault(require("components/QButton"));
const ResourceRegister_1 = __importDefault(require("components/ResourceRegister"));
const QDialogs_1 = __importDefault(require("components/QDialogs"));
const DeleteDialog_1 = __importDefault(require("components/ResourceRegister/DeleteDialog"));
const utils_1 = require("../../utils");
const logger = (0, core_1.getLogger)('CategoriesSettings.js');
const styles = ({ palette, spacing, typography }) => ({
    sectionHeadline: {
        marginBottom: spacing(2),
        marginTop: spacing(4),
    },
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
        display: 'flex',
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: spacing(4),
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.icon.secondary,
        verticalAlign: 'center',
        marginTop: 0,
    },
    iconSpacing: {
        marginRight: spacing(1),
    },
    categoriesContainer: {
        overflow: 'hidden',
        position: 'relative',
        minHeight: spacing(4),
        borderRadius: 20,
        border: `1px solid ${palette.divider}`,
        backgroundColor: palette.surface.default,
    },
    noData: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        padding: `${spacing(4)} 0`,
    },
    bold: {
        fontWeight: typography.fontWeightMedium,
    },
});
const types = [
    { title: 'Income', value: 'INCOME' },
    { title: 'Expense', value: 'EXPENSE' },
];
// id, type, label, flex, editable, placeholder
const dataDictionary = (0, immutable_1.List)([
    { id: 'name',
        type: 'string',
        label: 'Category Name',
        flex: 3,
        editable: true,
        uniqueWith: ['parent'],
        placeholder: 'Name',
        hide: false,
    },
    { id: 'parent',
        type: 'CategoryField',
        label: 'Subcategory of',
        flex: 3,
        font: 'small',
        editable: true,
        defaultValue: '-',
        placeholder: 'None',
        hide: false,
    },
    { id: 'categoryType',
        type: 'select',
        choices: types,
        label: 'Type',
        flex: 2,
        editable: true,
        placeholder: 'Type',
        cascadeUpdate: true,
        hide: false,
    },
    { id: 'description',
        type: 'string',
        label: 'Description',
        flex: 4,
        font: 'small',
        editable: true,
        defaultValue: '-',
        placeholder: 'Description (optional)',
        hide: false,
    },
    { id: 'actions',
        type: 'actions',
        label: ' ',
        flex: 1,
        hide: false,
    },
]);
const ID_NEW = '0';
const DEFAULT_REASSIGN_CATEGORY = {
    id: '0',
    type: 'Uncategorized',
};
const useStyles = (0, mui_1.makeStyles)()(styles);
const CategoriesSettings = (props) => {
    const { getItems, data, isLoading, setDialog, txnsProps, dialogAlert, createItem, updateItem, deleteItem, } = props;
    const { classes } = useStyles();
    const chartOfAccounts = (0, react_redux_1.useSelector)((state) => chart_of_accounts_1.chartOfAccountsSelectors.getChartOfAccountsTree(state));
    const makeData = (flatten = false) => {
        logger.log('**Categories new data', data);
        return (0, utils_1.makeLocalCategoriesData)({
            categories: data,
            chartOfAccounts,
            flatten,
        });
    };
    const [categoriesData, setCategoriesData] = (0, react_1.useState)(makeData());
    const [flatData, setFlatData] = (0, react_1.useState)(makeData(true));
    const [reassignCategory, setReassignCategory] = (0, react_1.useState)(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    (0, react_1.useEffect)(() => {
        getItems();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        setCategoriesData(makeData());
        setFlatData(makeData(true));
        setReassignCategory(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps
    /**
     * Checking for duplicate category name under its parent only, same as QWin.
     * @param {Object} category // It's the category being added/edited.
     * @param {Object} parentCategory // It's the parent of above category that contains all its children.
     * @returns Boolean
     */
    const handleRequestCreate = () => {
        const newIndex = categoriesData.findIndex((x) => x.id === ID_NEW);
        if (newIndex < 0) {
            const newData = categoriesData.unshift((0, utils_1.makeNewCategoryObject)(ID_NEW));
            setCategoriesData(newData);
        }
    };
    const validateCategory = (category) => {
        let modal = null;
        // Check empty name
        if (!category.name || (category === null || category === void 0 ? void 0 : category.name.trim()) === '') {
            modal = {
                title: 'Unable to save category',
                body: 'You must specify a name for this category',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        const parent = (0, utils_1.getCategoryById)(category.values.parent.id, flatData) || {};
        const { id: parentId = '', level: parentLevel = 0 } = parent;
        // Check duplicate category name under its parent only
        if ((0, utils_1.checkForDuplicateCategory)(category, parent, flatData)) {
            modal = {
                title: `${category.name} already exists.`,
                body: 'You need to use a unique name',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        // Check maximum level
        const maxLevelAllowed = 16;
        const newCategoryLevel = (0, utils_1.getCategoryDepth)(category) + parentLevel;
        if (newCategoryLevel > maxLevelAllowed) {
            modal = {
                title: 'Unable to save category',
                body: 'Maximum level exceed. You must specify a different subcategory.',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        // Validate reassging same parent
        if (category.id === parentId) {
            modal = {
                title: 'Unable to save category',
                body: 'You must specify a different subcategory.',
                callback: lodash_1.noop,
                buttons: ['Got it'],
            };
        }
        if (modal) {
            dialogAlert(modal.title, modal.body, modal.callback, modal.buttons);
        }
        return !modal;
    };
    const removeNewItem = () => {
        const newData = categoriesData.filterNot((x) => x.id === ID_NEW);
        setCategoriesData(newData);
    };
    const handleSave = (category) => {
        var _a;
        if (validateCategory(category)) {
            const item = data.get(category.id) || categories_1.categoriesTypes.mkCategory();
            const parentType = category.values.parent.id !== '0' && ((_a = (0, utils_1.getCategoryById)(category.values.parent.id, flatData)) === null || _a === void 0 ? void 0 : _a.categoryType);
            const toSave = categories_1.categoriesTypes.mkCategory(Object.assign(Object.assign({}, category), { name: category.name.trim(), type: parentType || category.categoryType, parentId: category.values.parent.id, isDeleted: item.get('isDeleted'), knownCategoryId: item.get('knownCategoryId') }));
            if (category.id === ID_NEW) {
                core_1.tracker.track(core_1.tracker.events.categoryCreate, {
                    type: toSave.type,
                    level: category.level,
                    has_description: Boolean(category.description),
                });
                if (assert(toSave.name, `category name is required (name = '${toSave.name}') #bug-trap`)) {
                    createItem(toSave.merge({ id: undefined, clientId: (0, uuid_1.v4)().toUpperCase() }));
                }
                removeNewItem();
            }
            else {
                core_1.tracker.track(core_1.tracker.events.categoryEdit);
                updateItem(toSave);
            }
        }
    };
    // TODO: remove the reference to the given tag id from the transaction
    // const removeTxnCat = (txn, cat) => {
    //   if (transactionsUtils.isSplitTxn(txn)) {
    //     return txn.setIn(['split', 'items'],
    //       txn.split.items.map((item) => item.coa && item.coa.id === cat.id ?
    //         item.set('coa', chartOfAccountsTypes.mkChartOfAccount()) : item));
    //   }
    //   return txn.set('coa', chartOfAccountsTypes.mkChartOfAccount());
    // };
    const resetReassignCategory = () => {
        setReassignCategory(Object.assign({}, DEFAULT_REASSIGN_CATEGORY));
    };
    const deleteCategory = (category, hasTxns, txns, scheduledTxns, memTxns) => {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let reassignCat = Object.assign({}, ((0, immutable_1.isImmutable)(reassignCategory) ? reassignCategory.toJS() : reassignCategory));
        let txnsToChange = txns;
        let scheduledTxnsToChange = scheduledTxns;
        let memTxnsToChange = memTxns;
        if (reassignCat.id === DEFAULT_REASSIGN_CATEGORY.id) {
            reassignCat = Object.assign(Object.assign({}, reassignCat), { type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED });
        }
        else {
            reassignCat = Object.assign(Object.assign({}, reassignCat), { type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY });
        }
        txnsToChange = txnsToChange.map((txn) => (0, utils_1.reassignTxnCat)(txn, category, reassignCat)).toList();
        scheduledTxnsToChange = scheduledTxnsToChange.map((stxn) => stxn.set('transaction', (0, utils_1.reassignTxnCat)(stxn.transaction, category, reassignCat))).toList();
        memTxnsToChange = memTxnsToChange.map((memTxn) => (0, utils_1.reassignMemPayeeCat)(memTxn, category, reassignCat)).toList();
        /* TODO when memorized transactions are enabled
         * Remove references to this tag in all memorized transactions
         */
        if (category.id !== reassignCat.id) {
            core_1.tracker.track(core_1.tracker.events.categoryDelete, { has_transactions_assigned: hasTxns });
            deleteItem(Object.assign(Object.assign({}, category), { isDeleted: true }));
            if (hasTxns) {
                if (txnsToChange.size > 0) {
                    txnsProps.batchTransactions(txnsToChange);
                }
                scheduledTxnsToChange.forEach((txn) => txnsProps.updateScheduledTransaction(txn));
                if (memTxnsToChange.size > 0) {
                    txnsProps.updateMemTransactions(memTxnsToChange);
                }
            }
        }
        else {
            setTimeout(() => {
                setDialog('Delete the Category', <>
            Unable to delete the category
            <strong className={classes.bold}> “{category.name}”</strong>. <br />
            Can&apos;t reassign to the same category.
          </>, () => {
                    handleDelete(category); // eslint-disable-line @typescript-eslint/no-use-before-define
                }, ['Got it']);
            }, 50);
        }
    };
    const handleDelete = (category) => {
        const { txnsToChange, scheduledTxnsToChange, memTransactionToChange } = (0, utils_1.getTxnsToChange)(category, txnsProps);
        const hasTxns = txnsToChange.size > 0 || scheduledTxnsToChange.size > 0 || memTransactionToChange.size > 0;
        const deleteText = hasTxns ? 'Reassign & Delete' : 'Delete';
        const isLastCategory = categoriesData.size === 1;
        const hasChildren = category.children && category.children.length > 0;
        if (isLastCategory) {
            setDialog('Delete Category', 'We are unable to delete the last category', undefined, ['OK']);
        }
        else {
            setDialog('Delete the Category', <DeleteDialog_1.default category={category} hasTxns={hasTxns} 
            // @ts-expect-error: Type 'boolean | null' is not assignable to type 'boolean'.
            hasChildren={hasChildren} txnsToChange={txnsToChange.size} scheduledTxnsToChange={scheduledTxnsToChange.size} memTxnsToChange={memTransactionToChange.size} reassignCategory={reassignCategory} setReassignCategory={setReassignCategory}/>, (dialog) => {
                if ([deleteText, 'Enter'].includes(dialog === null || dialog === void 0 ? void 0 : dialog.action)) {
                    deleteCategory(category, hasTxns, txnsToChange, scheduledTxnsToChange, memTransactionToChange);
                    resetReassignCategory();
                }
                if (['Close', 'Escape', 'Cancel'].includes(dialog === null || dialog === void 0 ? void 0 : dialog.action)) {
                    resetReassignCategory();
                }
            }, ['Cancel', deleteText]);
        }
    };
    return (<>
      <Grid_1.default className={classes.sectionHeadline} container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Typography_1.default variant="h5" className={classes.headlineText}>
          <TurnedInNotRounded_1.default className={classes.headlineIcon}/>
          Categories
        </Typography_1.default>
        <QButton_1.default id="categories-add-new-button" variant="contained" onClick={handleRequestCreate}>
          <Add_1.default className={classes.iconSpacing}/> CATEGORY
        </QButton_1.default>
      </Grid_1.default>
      <Grid_1.default className={classes.categoriesContainer} container>
        {categoriesData.size ?
            <ResourceRegister_1.default dataDictionary={dataDictionary.filterNot((x) => x.hide)} data={categoriesData} onSave={handleSave} 
            // @ts-expect-error: Type '(category: CategoryData) => void' is not assignable
            onDelete={handleDelete} onRemoveNewItem={removeNewItem} getCategoryByID={(id) => (0, utils_1.getCategoryById)(id, flatData)} 
            // @ts-expect-error:  Target signature provides too few arguments. Expected 2 or more, but got 1.
            setDialog={setDialog}/> :
            !isLoading &&
                <Typography_1.default className={classes.noData} component="p" variant="subtitle2">
              No categories available. Please click the button to add a new category
            </Typography_1.default>}
      </Grid_1.default>
    </>);
};
exports.CategoriesSettings = CategoriesSettings;
exports.default = (0, QDialogs_1.default)()(exports.CategoriesSettings);
